import {
  Box,
  CircularProgress,
  FormControlLabel,
  Radio,
  RadioGroup,
  Typography,
} from '@mui/material'
import { SchedulerPageFrame } from './SchedulerBrandBar'
import { SECTIONS } from './SchedulerInput.sections'
import {
  PageHeader,
  Button as SButton,
  CalendarInput,
  Input,
} from 'Common/Supplyvue-ui'
import { useNavigate } from 'react-router-dom'
import { FormControl } from '@mui/material'
import { useBreadcrumbsData } from 'Common/Breadcrumbs/Breadcrumbs.data'
import { ChangeEvent, useState } from 'react'
import { PLAN_ACCESS_TYPE } from 'Common/Constants/Constants'
import toast from 'react-hot-toast'
import { useCreateScheule } from './Scheduler.data'
import { CreateSheduleParams } from './Scheduler.types'

const defaultShedulerData: CreateSheduleParams = {
  name: '',
  startDate: new Date(),
  accessType: PLAN_ACCESS_TYPE.PUBLIC,
}
export const CreateSchedulerPage = () => {
  const navigate = useNavigate()
  useBreadcrumbsData({
    plan_id: '',
  })
  const [schedulerData, setSchedulerData] =
    useState<CreateSheduleParams>(defaultShedulerData)
  const handleInputChange = (value: string | Date, keyName: string) => {
    setSchedulerData({
      ...schedulerData,
      [keyName]: value,
    })
  }

  // Straight into the new schedule's production requirements — the first
  // thing anyone does with a new schedule — rather than back to the list.
  const onSuccess = (created?: { id: string; iteration: string }) => {
    toast.success('Schedule successfully created')
    navigate(
      created
        ? `/plan-scheduler/input/${created.id}/${created.iteration}?section=${SECTIONS.PRODUCTION_REQUIREMENT}`
        : '/plan-scheduler'
    )
  }

  const onFailure = () => {
    toast.error('Create schedule failed')
  }

  const { mutate: createShedule, isLoading: isSheduleCreating } =
    useCreateScheule(onSuccess, onFailure)

  const handleCreateShedule = () => {
    createShedule(schedulerData)
  }
  return (
    <SchedulerPageFrame
      crumbs={[{ label: 'Create schedule' }]}
      // The old `Page` padding, so the form sits where it always has.
      bodySx={{ p: '36px' }}
    >
      <Box display="flex" flexDirection="column" flex={1}>
        <PageHeader title="Create schedule" />
        <Box display="flex" flexDirection="column" flex={1} alignItems="center">
          <Box width="40%">
            <Box
              display="flex"
              flexDirection="row"
              justifyContent="space-between"
              marginTop={2}
            >
              <Box display="flex" alignItems="center" width="20%">
                <Typography>Schedule start week</Typography>
              </Box>
              <Box marginLeft={3}>
                <CalendarInput
                  label="Schedule start week"
                  sx={{ width: '300px' }}
                  format="dd-MM-yyyy"
                  onChange={(date) => {
                    handleInputChange(date ?? new Date(), 'startDate')
                  }}
                  value={schedulerData.startDate}
                  disabled={isSheduleCreating}
                />
              </Box>
              <Box display="flex" alignItems="center" width="20%"></Box>
            </Box>

            <Box
              display={'flex'}
              flexDirection="row"
              marginTop={2}
              justifyContent="space-between"
            >
              <Box display="flex" alignItems="center" width="20%">
                <Typography>Schedule description</Typography>
              </Box>
              <Box marginLeft={3}>
                <Input
                  sx={{ width: '300px' }}
                  value={schedulerData.name}
                  onChange={(e) => {
                    handleInputChange(e.target.value, 'name')
                  }}
                  disabled={isSheduleCreating}
                  placeholder="Enter Schedule description"
                />
              </Box>
              <Box display="flex" alignItems="center" width="20%"></Box>
            </Box>

            <Box
              display={'flex'}
              flexDirection="row"
              marginTop={2}
              justifyContent="space-between"
            >
              <Box display="flex" alignItems="center" width="20%">
                <Typography>Schedule access</Typography>
              </Box>
              <Box marginLeft={3}>
                <FormControl>
                  <RadioGroup
                    aria-labelledby="plan-access-radio-buttons-group"
                    name="controlled-radio-buttons-group"
                    value={schedulerData.accessType}
                    onChange={(event: ChangeEvent<HTMLInputElement>) => {
                      handleInputChange(event.target.value, 'accessType')
                    }}
                    row
                  >
                    <FormControlLabel
                      value={PLAN_ACCESS_TYPE.PRIVATE}
                      control={<Radio />}
                      label="Private"
                    />
                    <FormControlLabel
                      value={PLAN_ACCESS_TYPE.PUBLIC}
                      control={<Radio />}
                      label="Public"
                    />
                  </RadioGroup>
                </FormControl>
              </Box>
              <Box
                display="flex"
                alignItems="center"
                width="20%"
                paddingLeft={1}
              ></Box>
            </Box>

            <Box
              display={'flex'}
              flexDirection="row"
              marginTop={2}
              justifyContent="space-between"
            >
              <Box display="flex" alignItems="center" width="20%"></Box>
              <Box>
                <SButton
                  onClick={handleCreateShedule}
                  sx={{ marginLeft: '20px', minWidth: '105px' }}
                  label="Create plan"
                  variant="contained"
                  disabled={schedulerData.name == '' || isSheduleCreating}
                >
                  {isSheduleCreating && (
                    <CircularProgress
                      color="inherit"
                      size={16}
                      sx={{ marginRight: '8px' }}
                    />
                  )}
                  Schedule
                </SButton>
              </Box>
              <Box
                display="flex"
                alignItems="center"
                width="20%"
                paddingLeft={1}
              ></Box>
            </Box>
          </Box>
        </Box>
      </Box>
    </SchedulerPageFrame>
  )
}
